module.exports = "/assets/data/78b8a170d3604cf30e8b94ecb4cdffb2-WF17.data.json";